module.exports = __webpack_public_path__ + "static/media/VCG41N1069771644.e7589943.jpg";